import { countries } from '../helpers/countries';
import { provinces } from '../helpers/provinces';
import { applicantFields, peCoverageField, } from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'insurecanadavisitor';
const org = 'insurecanada';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Agent'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.mqGroup(),
    fieldGroups.mqGroupOld(),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.beneficiaryGroup(clientName),
    fieldGroups.bqGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(true),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
    fieldGroups.attachmentGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      ...peCoverageField('0', org),
    ],
    dependent_fields: [
      ...applicantFields('*', [
        { value: 'dependent', text: 'Dependent' },
        { value: 'travelling companion', text: 'Travelling Companion' },
        { value: 'spouse', text: 'Spouse' }
      ]),
      ...peCoverageField('*', org),
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'policy_type'],
        as: 'Policy Type',
        type: 'dropdown',
        options: [
          { value: 'standard', text: 'Standard' },
          { value: 'enhanced', text: 'Enhanced' }
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries().filter(country => (country.value !== 'CA'))
      },
      {
        key_path: ['application', 'additional_data', 'destination_province'],
        as: 'Destination Province',
        type: 'dropdown',
        options: [
          {
            value: 'N/A',
            text: 'N/A'
          },
          ...provinces('CA')
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'tracking_code'],
          value: 'IC004'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'destination_province'],
        as: 'Destination Province',
        type: 'dropdown',
        options: [
          {
            value: 'N/A',
            text: 'N/A'
          },
          ...provinces('CA').filter(province => (province.value !== 'QC'))
        ],
        show_if: [{
          key_path: ['application', 'additional_data', 'tracking_code'],
          value: 'IC004'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'in_canada'],
        as: 'Are applicants currently in Canada?',
        type: 'radio',
        options: [
          { value: 'no', text: 'No' },
          { value: 'yes', text: 'Yes' }
        ]
      },
      {
        key_path: ['application', 'additional_data', 'super_visa'],
        as: 'Are applicants travelling to Canada on a Super Visa?',
        type: 'radio',
        options: [
          { value: 'no', text: 'No' },
          { value: 'yes', text: 'Yes' }
        ]
      },
      {
        key_path: ['application', 'additional_data', 'coverage'],
        as: 'Coverage',
        type: 'dropdown',
        options: [
          { value: 25000, text: '$25,000.00 CAD' },
          { value: 50000, text: '$50,000.00 CAD' },
          { value: 100000, text: '$100,000.00 CAD' },
          { value: 150000, text: '$150,000.00 CAD' },
          { value: 500000, text: '$500,000.00 CAD' },
          { value: 1000000, text: '$1,000,000.00 CAD' }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'super_visa'],
          value: 'yes'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'coverage'],
        as: 'Coverage',
        type: 'dropdown',
        options: [
          { value: 100000, text: '$100,000.00 CAD' },
          { value: 150000, text: '$150,000.00 CAD' },
          { value: 500000, text: '$500,000.00 CAD' },
          { value: 1000000, text: '$1,000,000.00 CAD' }
        ],
        show_if: [{
          key_path: ['application', 'additional_data', 'super_visa'],
          value: 'yes'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'deductible'],
        as: 'Deductible',
        type: 'dropdown',
        options: [
          { value: 0, text: '$0.00 CAD' },
          { value: 100, text: '$100.00 CAD' },
          { value: 250, text: '$250.00 CAD' },
          { value: 500, text: '$500.00 CAD' },
          { value: 1000, text: '$1,000.00 CAD' },
          { value: 3000, text: '$3,000.00 CAD' }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/clients/insurecanadavisitor.js